import { Injectable } from '@angular/core';

import * as DefaultFeatureConfig from 'feature-flag-config/generated/features';
import * as ProductionFeatureConfig from 'feature-flag-config/generated/features.prod';
import { IFeatureConfig } from 'feature-flag-config/feature-config-model';

import { WindowRef } from 'core/window-ref.service';
import { AppPersistantStateService, StoreNames } from 'core/state/app-state.service';

@Injectable({ providedIn: 'root' })
export class FeatureFlagConfigProviderService {

  private get currentFeatureEnvironment() {
    return this._appPersistantStateService.getValue(StoreNames.FeatureEnvironment);
  }
  /**
   *
   */
  constructor(
    private _appPersistantStateService: AppPersistantStateService,
    private _windowRef?: WindowRef
  ) {
    if (this.currentFeatureEnvironment === 'prod') {
      console.warn('Using production feature config because localStorage.feature_environment is set to "prod"');
    }
  }

  getFeatureConfig(): IFeatureConfig {
    if (this.currentFeatureEnvironment === 'prod') {
      return ProductionFeatureConfig.Features;
    }
    try {
      const overrideSettings = this._windowRef?.nativeWindow?.__FEATURE_FLAG_OVERRIDES__;
      if (!overrideSettings) {
        return DefaultFeatureConfig.Features;
      }
      const features = { ...DefaultFeatureConfig.Features, ...overrideSettings };
      return features;
    } catch (e) {
      console.warn(`Error attempting to override FeatureFlags; so using default config`, e, DefaultFeatureConfig.Features);
      return DefaultFeatureConfig.Features;
    }
  }
}
